import {useMutation, useQuery} from "@tanstack/react-query";
import {toast} from "sonner";
import * as m from "@/paraglide/messages";
import {
  fetchInfluenceGraph,
  fetchPost,
  fetchSuggestions,
  launchBots,
  type DataSource,
  type LaunchRequest,
  type LaunchResponse,
  type Post,
  type SuggestionsResponse,
} from "@/lib/influence-api";

const INFLUENCE_POST_KEY = "influence-post";
const INFLUENCE_SUGGESTIONS_KEY = "influence-suggestions";
const INFLUENCE_GRAPH_KEY = "influence-graph";

export function useInfluenceGraph(source: DataSource) {
  return useQuery({
    queryKey: [INFLUENCE_GRAPH_KEY, source],
    queryFn: () => fetchInfluenceGraph(source),
    staleTime: 5 * 60 * 1000,
  });
}

export function usePost(postId: string | undefined) {
  return useQuery<Post, Error>({
    queryKey: [INFLUENCE_POST_KEY, postId],
    queryFn: () => fetchPost(postId!),
    enabled: !!postId,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
}

export function useSuggestions(postId: string | undefined) {
  return useQuery<SuggestionsResponse, Error>({
    queryKey: [INFLUENCE_SUGGESTIONS_KEY, postId],
    queryFn: () => fetchSuggestions(postId!),
    enabled: !!postId,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
}

export function useLaunchBots(options?: {onSuccess?: (data: LaunchResponse) => void}) {
  return useMutation<LaunchResponse, Error, LaunchRequest>({
    mutationFn: launchBots,
    onSuccess: (data) => {
      toast.success(data.message);
      options?.onSuccess?.(data);
    },
    onError: () => {
      toast.error(m.post_campaign_launch_error());
    },
  });
}
